var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":"http://testbed.gr:3000/public/dashboard/2ccc5d1e-6f9e-49c6-8a70-741be671262e","frameborder":"0","width":"800","height":"600","allowtransparency":""}})}
var staticRenderFns = []

export { render, staticRenderFns }